/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSSVariableValue} from '../../../assets/ts/_utils'
// import {FiDollarSign} from 'react-icons/fi'
// import {FiBarChart} from 'react-icons/fi'

import {Link} from 'react-router-dom'
import {AiOutlineArrowLeft} from 'react-icons/ai'
import icon1 from '../../../../assets/investmentStatus/1.svg'
import icon2 from '../../../../assets/investmentStatus/2.svg'
import icon3 from '../../../../assets/investmentStatus/3.svg'

import './MixedWidget11.css'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
}

const MixedWidget11: React.FC<Props> = ({className, chartColor, chartHeight}) => {
  const [shareholder, setShareholder] = useState(false)

  return (
    <div className={`bg-white statusInvestment shadow rounded-lg  ${className}`}>
      {shareholder ? (
        <>
          {/* begin::Body */}
          <div className=' p-0 flex justify-between flex-column overflow-hidden mt-1 statusHeader'>
            {/* begin::Hidden */}
            <div dir={'rtl'} className='InvestmentTitle flex flex-stack flex-wrap '>
              <div className='mx-3'>
                <span className='text-lg font-bold pr-8	 leading-8block'>
                  {' '}
                  وضعیت سرمایه گذاری شما{' '}
                </span>
                {/* <span className='text-gray-400 fw-bold'>نمودار وضعیت سهام کل  </span> */}
              </div>
            </div>
            {/* end::Hidden */}

            {/* begin::Chart */}
            {/* <div ref={chartRef} className='mixed-widget-10-chart'></div> */}
            {/* end::Chart */}

            <div className='flex flex-row-reverse justify-between  px-7  items-center iconInvest pb-4 py-4 '>
              <div className='flex items-center  flex-row-reverse'>
                <img src={icon1} alt='icon1' />
                <h4 className='d-flex pr-3 text-base leading-7		'> : مبلغ سرمایه گذاری شما</h4>
              </div>
              <div>
                <div className='flex text-base font-bold leading-7		'>
                  <span> میلیون تومان </span>
                  <span> 50 </span>
                </div>
              </div>
            </div>

            <div className='flex flex-row-reverse  justify-between  px-7  	  items-center iconInvest pb-4 py-4 '>
              <div className='flex items-center flex-row-reverse'>
                <img src={icon2} alt='icon2' />
                <h4 className='d-flex pr-3 text-base leading-7		'> : تعداد واحد سهام</h4>
              </div>
              <div className='flex text-base font-bold leading-7		'>
                <span> سهم </span>
                <span> 10 </span>
              </div>
            </div>

            <div className='flex flex-row-reverse justify-between  px-7    items-center iconInvest pb-4 py-4 '>
              <div className='flex items-center flex-row-reverse '>
                <img src={icon3} alt='icon3' />
                <h4 className='d-flex pr-3 text-base leading-7		'> : مبلغ سود</h4>
              </div>
              <div className='flex text-base font-bold leading-7		'>
                <span> میلیون تومان </span>
                <span> 20 </span>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className='InvestStart'>
          <Link to='/stock/sales'>
            <div className='text-right p-8 Invest'>
              <div className='light'></div>

              <div className='decInvestmnet mt-6'>
                <h3 className='font-extrabold leading-7 titleInvest'>
                  همین حالا سرمایه گذاری را شروع کنید
                </h3>
                <p className='font-light text-base leading-6 mt-3'>
                  با بیمارستان مهر ایرانیان، منحصر به فرد سرمایه گذار باشید
                </p>
              </div>

              {/* <div className='sttock  text-left'>
                <Link to='/stock/sales' className='buystock text-base font-bold	 leading-7	'>
                  <AiOutlineArrowLeft className='mr-4' />
                  خرید سهام
                </Link>
              </div> */}
            </div>
          </Link>
        </div>
      )}
    </div>
  )
}



const chartOptions = (chartColor: string, chartHeight: string): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const secondaryColor = getCSSVariableValue('--bs-gray-300')
  const baseColor = getCSSVariableValue('--bs-' + chartColor)

  return {
    series: [
      {
        name: 'Net Profit',
        data: [50, 60, 70, 80, 60, 50, 70, 60],
      },
      {
        name: 'Revenue',
        data: [50, 60, 70, 80, 60, 50, 70, 60],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: chartHeight,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    fill: {
      type: 'solid',
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '$' + val + ' revenue'
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      padding: {
        top: 10,
      },
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}

export {MixedWidget11}
